<p [hidden]=true id='browser' *isChrome>Chrome</p>
<p [hidden]=true id='browser' *isFirefox>Firefox</p>
<p [hidden]=true id='browser' *isSafari>Safari</p>
<p [hidden]=true id='browser' *isOpera>Opera</p>
<p [hidden]=true id='browser' *isIE>IE</p>
<p [hidden]=true id='device' *isIphone>iPhone</p>
<p [hidden]=true id='device' *isIpad>iPad</p>
<p [hidden]=true id='device' *isAndroidMobile>android mobile</p>
<p [hidden]=true id='device' *isAndroidTablet>android tablet</p>
<p [hidden]=true id='device' *isWindowsPhone>windows phone</p>'